import deviceType from '../constants/deviceType'

const deviceUtils = {
  /* 设备类型 */
  getDeviceType: function () {
    let ua = navigator.userAgent
    if (/(Android)/i.test(ua)) {
      return deviceType.Android
    } else if (/(iPhone|iPad|iPod|iOS)/i.test(ua)) {
      return deviceType.iOS
    } else {
      return deviceType.PC
    }
  },
  /* 安卓设备 */
  isAndroidDevice: function () {
    return this.getDeviceType() === deviceType.Android
  },
  /* 苹果设备 */
  isIOSDevice: function () {
    return this.getDeviceType() === deviceType.iOS
  },
  /* 微信浏览器 */
  isWeChatBrowser: function () {
    let ua = navigator.userAgent.toLowerCase()
    return /micromessenger/.test(ua)
  }
}

export default deviceUtils



// WEBPACK FOOTER //
// ./src/util/deviceUtils.js